import { AdminPermission } from '../../../services/commons/Me';
import { AdminPermissions, AdminPermissionsOnModule } from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';

export interface UserPermissionsOnBackOfficeUsersModule extends AdminPermissionsOnModule {
    readonly canEditFirstName?: boolean;
    readonly canEditLastName?: boolean;
    readonly canEditExternalReference?: boolean;

    readonly canEditEmail?: boolean;
    readonly canEditDescription?: boolean;
    readonly canEditFavoriteShops?: boolean;
    readonly canEditPermissions?: boolean;
}

export class BackUsersPermissions {
    public static BACK_USERS_CODE = 'BackOfficeUsers';

    public static Admin: UserPermissionsOnBackOfficeUsersModule = {};

    public static initializeBackUsersAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnBackUsers = AdminPermissions.filter(perms, BackUsersPermissions.BACK_USERS_CODE);

        const canWrite = AdminPermissions.hasWritePermission(permsOnBackUsers);
        BackUsersPermissions.Admin = {
            ...AdminPermissions.toAdminModulePermissions(permsOnBackUsers),
            canEditFirstName: canWrite,     //* same as canEditName
            canEditLastName: canWrite,      //* same as canEditName
            canEditEmail: canWrite,
            canEditDescription: canWrite,
            canEditFavoriteShops: canWrite,
            canEditPermissions: canWrite,
        };
        PermissionsAbilityHelper.logPermissions('BackOfficeUsers', BackUsersPermissions.Admin);
    };
}
